export default __webpack_public_path__ + "static/media/Prologue_KyoM2.6a4d0e18.svg";